export const query = `mutation Checkout(
    $items: [ItemInput!],
    $paymentToken: String,
    $customer: CustomerInput,
    $shipping: AddressInput,
    $billing: AddressInput,
    $coupons: [CouponInput!],
    $customFields: TransactionCustomFields,
    $paymentInstrument: PaymentInstrumentInput
  ) {
    checkout(
      items: $items,
      coupons: $coupons,
      customer: $customer,
      shipping: $shipping,
      billing: $billing,
      paymentInstruction: { token: $paymentToken }
      paymentInstrument: $paymentInstrument,
      customFields: $customFields
    ) {
      transaction {
        id,
        amount,
        status,
        result,
        planIds,
        paymentInstrument {
          method,
          paymentCardId
        }
      },
      customer {
        email,
        id
      }
    }
  }`
